<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>

<button
  #button
  mat-raised-button
  [class]="mode"
  [class.has-icon]="icon"
  [matMenuTriggerFor]="matMenuTrigger"
  [ngClass]="customColorClass || buttonClass"
  [ngStyle]="customStyles"
  [disabled]="disabled"
  [attr.type]="type"
  (click)="onClick($event)"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  *ngIf="mode !== 'basic' && mode !== 'icon'"
>
  <lib-cdw-icon
    *ngIf="icon"
    [icon]="icon"
    [useMatIcon]="useMatIcon"
    [customColor]="customIconColor"
    [size]="iconSize"
    [fill]="true"
    [outlined]="outlined">
  </lib-cdw-icon>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</button>

<button
  mat-button
  [matMenuTriggerFor]="matMenuTrigger"
  [ngClass]="buttonClass"
  [ngStyle]="customStyles"
  [disabled]="disabled"
  [attr.type]="type"
  (click)="onClick($event)"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  *ngIf="mode === 'basic'"
>
  <lib-cdw-icon
    *ngIf="icon"
    [icon]="icon"
    [useMatIcon]="useMatIcon"
    [customColor]="customIconColor"
    [size]="iconSize"
    [fill]="true"
    [outlined]="outlined">
  </lib-cdw-icon>
  <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</button>

<button
  mat-icon-button
  [matMenuTriggerFor]="matMenuTrigger"
  [ngClass]="buttonClass"
  [ngStyle]="customStyles"
  [disabled]="disabled"
  [attr.type]="type"
  (click)="onClick($event)"
  (focus)="onFocus($event)"
  (blur)="onBlur($event)"
  *ngIf="mode === 'icon'"
>
  <lib-cdw-icon
    [icon]="icon"
    [useMatIcon]="useMatIcon"
    [customColor]="customIconColor"
    [size]="iconSize"
    [fill]="true"
    [outlined]="outlined">
  </lib-cdw-icon>
</button>
